<template>
  <table class="table table-sm table-bordered table-sm">
    <thead>
      <tr>
        <th width="1%">Kundennummer</th>
        <th>Name</th>
        <th width="1%">Postleitzahl</th>
        <th width="1%">Ort</th>
        <th class="text-center" width="1%">Löschen</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="customer in customers" :key="customer._id">
        <td>{{ customer.customerId }}</td>
        <td>{{ customer.name }}</td>
        <td>{{ customer.zipcode }}</td>
        <td>{{ customer.city }}</td>
        <td>
          <button
            type="button"
            class="btn btn-sm btn-danger btn-block"
            :disabled="requesting || role === 'guest'"
            @click="onDelete(customer._id)"
          >
            <i class="fa fa-fw fa-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'customers-table',
  props: {
    customers: {
      type: Array,
      required: true,
    },
    requesting: {
      type: Boolean,
      required: true,
    },
    role: {
      type: String,
      default: 'guest',
    },
  },
  methods: {
    onDelete(id) {
      this.$emit('deleteCustomer', id);
    },
  },
};
</script>
